<template>
<div>
  <dialogC @close="$emit('close')" :transparent="true" :show="show" :width="820" label="新增兌換券" :height="870" :style="{left: 0}">
  <div class="boxCoupon" :style="{maxHeight: '815px'}">
    <div class="inputField" label="型態"><RT :options="['優惠券', '門票']" :defaultValue="mode" @input="mode=$event"/></div>
    <template v-if="mode==='門票'">
    <div class="radioField" label="使用期限"><div>
      <div><input type="radio" v-model="timeType" value="固定">
      <vue-ctk-date-time-picker :range="true" v-model="sendDate" id="cRange"
      @input="timeType='固定'"
       :style="{width: '330px'}"
        class="getDate"
        :only-date="true"
        :color="'var(--color-pri)'"
        :no-label="true"
        :auto-close="true"
        :input-size="'md'"
        :format="'YYYY-MM-DD'"
        :formatted="'YYYY-MM-DD'"
        :label="'請選擇日期'"
        />
      </div>
      <div :style="{
        display: 'flex', alignItems:'center', justifyContent:'space-between', marginTop: '15px'
      }">
        <div :style="{
        display: 'flex', alignItems:'center'
      }"><input type="radio"
        v-model="timeType" value="相對"><span>發券後</span>
        <input type="text" @click="timeType='相對'" v-model.number="duration" :style="{width: '60px'}">天</div>
        <div :style="{
        display: 'flex', alignItems:'center'
      }"><input type="radio"
        v-model="timeType" value="當天">發券當天</div>
      </div>
    </div></div>
    <div class="inputField" label="活動名稱"><input type="text" v-model="couponName" :style="{width: '585px'}"></div>
    <div class="inputField" label="贈品名稱"><input type="text" v-model="productName" :style="{width: '400px'}"></div>
    <div class="inputField" label="門票內容">
      <div class="prodname">{{prods.find(e => e._id === setID)?.name}}</div>
      <sqr40016 :icon="'edit'" :text="'門票內容'" :bg="'var(--color-pri)'" @click="selectItem='門票內容';prodsInCate=Sets[0].items"/>
    </div>
    </template>
    <template v-else>
    <div class="inputField" label="票券別" ><RT :options="types" :defaultValue="couponType" @input="couponType=$event"/></div>
    <div class="inputField" label="區域類型" ref="areaType">
        <RT :options="['包含下列區域', '排除下列區域']" :defaultValue="storeExclude ? '排除下列區域' : '包含下列區域'" @input="storeExclude=($event !== '包含下列區域')"/>
      </div>
    <div class="inputField" label="區域點" ref="area">
      <CheckboxVue :style="{flexDirection: 'row', flexWrap: 'wrap'}" :exclude="storeExclude"
      :options="restaurants" :defaultValue="store" @input="store=$event"/></div>
    <div class="inputField" label="活動名稱"><input type="text" v-model="couponName" :style="{width: '585px'}"></div>
    <div class="radioField" label="使用期限"><div>
      <div><input type="radio" v-model="timeType" value="固定">
      <vue-ctk-date-time-picker :range="true" v-model="sendDate" id="cRange"
      @input="timeType='固定'"
       :style="{width: '330px'}"
        class="getDate"
        :only-date="true"
        :color="'var(--color-pri)'"
        :no-label="true"
        :auto-close="true"
        :input-size="'md'"
        :format="'YYYY-MM-DD'"
        :formatted="'YYYY-MM-DD'"
        :label="'請選擇日期'"
        />
      </div>
      <div :style="{
        display: 'flex', alignItems:'center', justifyContent:'space-between', marginTop: '15px'
      }">
        <div :style="{
        display: 'flex', alignItems:'center'
      }"><input type="radio"
        v-model="timeType" value="相對"><span>發券後</span>
        <input type="text" @click="timeType='相對'" v-model.number="duration" :style="{width: '60px'}">天</div>
        <div :style="{
        display: 'flex', alignItems:'center'
      }"><input type="radio"
        v-model="timeType" value="當天">發券當天</div>
      </div>
    </div></div>
    <div class="inputField" label="贈品名稱"><input type="text" v-model="productName" :style="{width: '400px'}"></div>
    <div class="inputField" label="品項內容">
      <div class="prodname">{{prods.find(e => e._id === setID)?.name}}</div>
      <sqr40016 :icon="'edit'" :text="'折扣商品'" :bg="'var(--color-pri)'" @click="selectItem='折扣商品';prodsInCate=Sets[0].items"/>
    </div>
    <div class="inputField" label="折扣內容">
      <div class="prodname">{{Coupons.find(e => e._id === couponID)?.name}}</div>
      <sqr40016 :icon="'edit'" :text="'折扣內容'" :bg="'var(--color-pri)'" @click="selectItem='折扣內容'"/>
    </div>
    </template>
    <div class="inputField" label="票券轉贈">
      <RTT :options="['可轉贈', '不可轉贈']" :width="'130px'"  :defaultValue="CanBeTransferred" @input="CanBeTransferred=$event"/>
    </div>
    <div class="inputField point" label="兌換條件"><input type="text" v-model.number="pointExchange" :style="{width: '150px'}"><span>點</span></div>
    <div class="imageField" label="贈品圖片">
      <label for="img" id="uploadimage" v-if="!image">
        <div class="uploadimage">
        <input type="file" id="img" accept="image/png, image/jpeg" @change="uploadFile($event, 'coupons')" hidden>
        </div>
      </label>
      <div v-else @click="image=null"><img class="imageBox" :src="`.${image.filename}`"></div>
    </div>
    <div class="info">
      <div>注意事項</div>
      <textarea v-model="description"></textarea>
    </div>
    <div class="btns">
      <button class="cancel" @click="$emit('close')">取消</button>
      <button class="confirm" @click="save" :disabled="!vaild">儲存</button>
    </div>
  </div>
</dialogC>
  <dialogC v-if="selectItem" :show="selectItem" :label="selectItem" @close="selectItem=null" :style="{left: 0}">
    <div class="box1" v-if="selectItem === '折扣商品'||selectItem === '門票內容'">
      <div>
        <div class="cate" v-for="(product, p) in Sets" @click="prodsInCate=product.items" :key="`products-${p}`" :class="product.t">{{product.category||'其他'}}</div>
      </div>
      <div>
        <div class="prod" v-for="(product, p) in prodsInCate" @click="setSetID(product._id)" :key="`prods-${p}`">
          <div v-html="(product.name||'其他').replaceAll('\n', '<br>')" :style="{marginRight: '15px'}"></div>
          <div :class="agencyID&&(product.specialPrice?product.specialPrice[agencyID]:null)?'linethrough':''">${{product.price}}</div>
          <div v-if="agencyID&&(product.specialPrice?product.specialPrice[agencyID]:null)">${{product.specialPrice?product.specialPrice[agencyID]:''}}</div>
        </div>
      </div>
    </div>
    <div class="box2" v-if="selectItem === '折扣內容'">
      <discountCubeVue v-for="(discount, p) in Coupons" @click="setCouponID(discount._id)" :key="`prods-${p}`" :discount="discount"/>
    </div>
  </dialogC>
</div>
</template>

<script>
import discountCubeVue from '../CouponScheduleList/discountCube.vue'
import sqr40016 from '../../components/btn/sqr40016.vue'
import CheckboxVue from '../../components/checkbox/checkbox.vue'
import RTT from '../../components/radio/r1_radio.vue'
import dialogC from '../../components/dialognoPadding2.vue'
import { uploadimage, putapi } from '../../store/fetch'
import { mapState } from 'vuex'
const STORENAME = process.env.VUE_APP_STORENAME_SHORT
export default {
  name: 'NewCoupon',
  props: ['Sets', 'Coupons', 'types', 'show'],
  components: { dialogC, RTT, CheckboxVue, sqr40016, discountCubeVue },
  data () {
    return {
      agencyID: null,
      prodsInCate: [],
      selectItem: null,
      store: [],
      storeExclude: false,
      couponType: '抵用券',
      mode: '優惠券',
      sendDate: null,
      couponID: null,
      setID: null,
      CanBeTransferred: '可轉贈',
      couponName: null,
      productName: null,
      pointExchange: null,
      productID: null,
      startTime: null,
      expireTime: null,
      duration: null,
      timeType: '固定',
      image: null,
      description: `˙本商品電子兌換券由${STORENAME}提供服務。
˙本商品電子兌換，可於${STORENAME}進行兌換，恕無法其他分店使用。
˙本券恕不得更換其他商品或現金，禁止轉售與退換貨。
˙本券兌換券可兌換指定服務乙次。
˙本商品兌換券僅限每支行動裝置可兌換乙次，不得重複使用。
˙本店保留修改、中止使用方案之權利，若有修改或中止之情形，將於LINE官方帳號/FB粉絲專頁公告。`
    }
  },
  computed: {
    vaild () {
      if (!(this.sendDate && this.sendDate.start && this.sendDate.end) && !this.duration && (this.timeType !== '當天')) {
        return false
      }
      if (!this.couponName) {
        return false
      }
      if (!this.productName) {
        return false
      }
      if (!this.image) {
        return false
      }
      if (!this.description) {
        return false
      }
      return true
    },
    prods () {
      return [].concat(...this.Sets.map(e => e.items))
    },
    ...mapState({
      restaurants: 'restaurants'
    })
  },
  methods: {
    setSetID (ev) {
      this.setID = ev
      this.couponID = null
      this.selectItem = null
    },
    setCouponID (ev) {
      this.couponID = ev
      this.setID = null
      this.selectItem = null
    },
    async uploadFile (event, folder) {
      const ret = await uploadimage(event, folder)
      const image = ret
      image.filename = `/coupons/${image.filename}`
      this.image = image
    },
    async save () {
      const data = {
        mode: this.mode,
        CanBeTransferred: this.CanBeTransferred === '可轉贈',
        store: this.mode === '門票' ? [] : this.store,
        storeExclude: this.storeExclude,
        couponType: this.mode === '門票' ? '門票' : this.couponType,
        couponName: this.couponName,
        productName: this.productName,
        pointExchange: this.pointExchange,
        image: this.image.filename,
        couponID: this.mode === '門票' ? null : this.couponID,
        description: this.description,
        status: '暫存'
      }
      if (this.setID) {
        const set = this.prods.find(e => e._id === this.setID)
        if (set && set.t === 'set') {
          data.setID = this.setID
          data.productID = null
        } else if (set && set.t === 'single') {
          data.productID = this.setID
          data.setID = null
        }
      }
      if (this.timeType === '相對') {
        data.startTime = null
        data.expireTime = null
        data.duration = this.duration
      } else if (this.timeType === '當天') {
        data.startTime = null
        data.expireTime = null
        data.duration = 0
      } else {
        data.startTime = this.moment(this.sendDate.start).startOf('day').toDate()
        data.expireTime = this.moment(this.sendDate.end).endOf('day').toDate()
        data.duration = null
      }
      const r = await putapi('pointExchange', data)
      if (r) {
        this.$emit('new', r)
      }
    }
  }
}
</script>
<style lang="scss">
.boxCoupon {
  overflow-y: auto;
  .datetimepicker {
    div {
      box-sizing: border-box;
    }
  }
  #cRange-wrapper {
    width: 400px!important;
  }
  #cRange-input {
    width: 400px!important;
    text-align: start!important;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #5E5E5E;
    margin-inline: 6px;
    text-align: center;
  }
  .datepicker-container.range.has-shortcuts {
    display: grid;
    grid-template-columns: 140px 260px;
  }
  .field {
    width: 400px!important;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 9px;
      width: 36px;
      height: 36px;
      mask-size: contain;
      background-color: var(--color-checked);
      mask-size: 22px;
      mask-repeat: no-repeat;
      mask-position: 8px 9px;
      mask-image: url(./calendar2.svg);
    }
  }
  .custom-button {
    margin-right: 45px;
  }
}
</style>
<style lang="scss" scoped>
.prodname {
  font-size: 20px;
  letter-spacing: .05em;
  color: var(--color-pri);
  font-weight: 500;
  text-decoration-line: underline;
}
.prod {
  width: 340px;
  height: 85px;
  background-color: var(--color-bar);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  padding-inline: 15px;
  &>:nth-child(1) {
    text-align: start;
  }
}
.cate {
  width: 105px;
  height: 85px;
  min-height: 85px;
  background-color: var(--color-pri);
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  gap: 5px;
  &.set::before {
    content: '';
    background-image: url(/svg/icon/set.svg);
    display: inline;
    width: 25px;
    height: 25px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  &.single::before {
    content: '';
    background-image: url(/svg/icon/single.svg);
    display: inline;
    width: 25px;
    height: 25px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
}
.box2 {
  width: 739px;
  height: 650px;
  max-height: 650px;
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
}
.box1 {
  overflow: hidden;
  display: grid;
  grid-template-columns: 140px 1fr;
  height: 650px;
  &>:nth-child(1) {
    background-color: var(--color-bar);
    border-radius: 0 0 0 10px;
    overflow-y: auto;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  &>:nth-child(2) {
    display: flex;
    flex-direction: row;
    overflow-y: auto;
    flex-wrap: wrap;
    padding: 16px 19px;
    gap: 15px;
    width: 739px;
    align-items: flex-start;
    justify-content: flex-start;
    align-content: flex-start;
    justify-items: center;
  }
}
.imageBox {
  width: 550px;
  margin-left: 23px;
  border-radius: 3px;
}
.btns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  margin-top: 40px;

  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.saveAs {
      background: #CCA16E;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }

}
.radioField {
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
  &::before {
    margin-top: 7px;
    content: attr(label);
    display: inline-flex;
    width: 80px;
    text-align: start;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    color: #5E5E5E;
    text-align: right;
  }
  &>div > div {
    margin-bottom: 8px;
    height: 40px;
    display: flex;
    align-items: center;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #5E5E5E;
  }
  input[type=text] {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 3px;
    height: 40px;
    margin-top: 2px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #5E5E5E;
    margin-inline: 6px;
    text-align: center;
  }
}
input[type=radio] {
  height: 40px;
  border: none;
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  &::before {
    display: inline-block;
    box-sizing: border-box;
    content: '';
    width: 24px;
    height: 24px;
    border-radius: 12px;
    border: 2px solid var(--color-pri);
  }
  &:checked::before {
    background-image: url(./checked.svg);
    background-color: var(--color-checked);
    background-position: center;
  }
  &::after {
    content: attr(label);
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    color: #5E5E5E;
  }

}
.imageField {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 42px;
  &::before {
    content: attr(label);
    display: inline-flex;
    width: 80px;
    text-align: start;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    color: #5E5E5E;
    text-align: right;
  }
  #uploadimage {
    margin-left: 20px;
  }
}
.inputField {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 18px;
  gap: 15px;
  &::before {
    content: attr(label);
    display: inline-flex;
    width: 80px;
    min-width: 80px;
    text-align: start;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    color: #5E5E5E;
    text-align: right;
  }
  input[type=text] {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 3px;
    height: 40px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0.1em;
    color: #5E5E5E;
    padding-inline: 12px;
  }
}
.point {
  span {
    color: #6D6D6D;
    /* Notot Sans TC/Regular/20 */
    font-family: Noto Sans TC;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 2px;
  }
  input[type=text] {
    color: var(--highlight);
    font-family: Noto Sans TC;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 2.4px;
    text-align: center;
    height: 45px;
  }
}
label#uploadimage {
  width: 600px;
  height: 450px;
}
.uploadimage {
  margin-right: auto;
  width: 600px;
  height: 450px;
  background-image: url(./upload.svg);
  display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: left;
  position: relative;
  &::before {
    position: absolute;
    content: '匯入圖片';
    display: inline-flex;
    width: 100px;
    height: 35px;
    background-color: var(--color-checked);
    align-items: center;
    justify-content: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    left: 300px;
    top: 262px;
    transform: translateX(-50%);
  }
}
.info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  div {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
    text-align: start;
  }
  textarea {
    padding: 21px;
    width: 700px;
    height: 450px;
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 3px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 35px;
    letter-spacing: 0.1em;
    color: #848484;
  }
}
.boxCoupon {
  padding-block: 24px;
  &>div {
    padding-inline: 30px;
  }
  padding-inline: 20px;

}
</style>
